
import React, { useState, useContext } from "react";
import { Badge, Drawer, List, Avatar } from "antd";
import {
  HomeOutlined,
  AppstoreOutlined,
  UserOutlined,
  MessageOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import StartMenu from "./Start/StartMenu";
import {
  settingsPath,
  settingsPersonalPath,
  startMenuPath,
} from "../../routes/routes";
import {
  getMessagesService,
} from "../../../infrastructure/services/NotificationsService";
import { UiTextsContext, UserDataContext } from "../../contexts/Contexts";
import { showErrorMessage } from "../utils/messages";
import "./styles/BottomNav.css";

const NewSideBar = () => {
  const { userData } = useContext(UserDataContext);
  const { texts } = useContext(UiTextsContext);

  const [showStartMenu, setShowStartMenu] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(false);

  // Función que llama a tu servicio y abre el Drawer
  const fetchMessages = async () => {
    try {
      setLoadingMessages(true);
      const msgs = await getMessagesService(userData?.idUsuario);
      setMessages(msgs);
      setChatVisible(true);
    } catch (error) {
      console.error("Error fetching messages", error);
      showErrorMessage(
        "Error al obtener los mensajes, por favor inténtalo de nuevo más tarde."
      );
    } finally {
      setLoadingMessages(false);
    }
  };

  // Si clicaste en +, mostramos StartMenu
  if (showStartMenu) {
    return <StartMenu />;
  }
  

  return (
    <>
      <div className="bottom-nav">
        {/* Start */}
        <div className="nav-item">
          <Link to={startMenuPath} className="nav-link">
            <HomeOutlined className="nav-icon" />
            <span>{texts?.LB0094}</span>
          </Link>
        </div>

        {/* Feed */}
        <div className="nav-item">
          <Link to="/" className="nav-link">
            <AppstoreOutlined className="nav-icon" />
            <span>{texts?.LB0050}</span>
          </Link>
        </div>

        {/* Profile */}
        <div className="nav-item">
          <Link to={settingsPath} className="nav-link">
            <UserOutlined className="nav-icon" />
            <span>{texts?.LB0096}</span>
          </Link>
        </div>

        {/* Chat */}
        {/* <div className="nav-item nav-chat">
          <Badge dot={false} offset={[-3, 2]}>
            <div
              className="nav-link"
              onClick={fetchMessages}
              style={{ cursor: "pointer" }}
            >
              <MessageOutlined className="nav-icon" />
              <span>Chat</span>
            </div>
          </Badge>
        </div> */}
      </div>

      {/* Inbox Drawer */}
      {/* <Drawer
        title="Mensajes"
        placement="right"
        onClose={() => setChatVisible(false)}
        visible={chatVisible}
        width={320}
      >
        <List
          loading={loadingMessages}
          dataSource={messages}
          locale={{ emptyText: "No hay mensajes" }}
          renderItem={(msg) => (
            <List.Item key={msg.id}>
              <List.Item.Meta
                avatar={<Avatar src={msg.senderAvatar} />}
                title={
                  <Link to={`/chat/${msg.senderId}`}>
                    {msg.senderName}
                  </Link>
                }
                description={msg.text}
              />
            </List.Item>
          )}
        />
      </Drawer> */}
    </>
  );
};

export default NewSideBar;